import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { g_Dialog } from "@/main";
import DataManager from "@/data/DataManager";
import LoginPage from "@/components/LoginPage.vue";
import MainContent from "@/MainContent.vue";
import DataGrid from "@/components/DataGrid.vue";
import DataChart from "@/components/DataChart.vue";
import ChargeStationMap from "@/components/ChargeStationMap.vue";
import ClientsView from "@/components/ClientsView.vue";
import UserSettings from "@/components/UserSettings.vue";
import DashBoard from "@/components/DashBoard.vue";
import CurrentState from "@/components/CurrentState.vue";
import ChargingStationControl from "@/components/ChargingStationControl.vue";
// import ChargingStationConfiguration from "@/components/ChargingStationConfiguration.vue";
// import ToDo from "@/components/ToDo.vue";

const routes = [
  { name: "login", path: "/login", component: LoginPage, props: true },
  {
    name: "MainContent",
    path: "/MainContent",
    component: MainContent,
    meta: {
      title: "",
      require_login: true,
    },
    children: [
      {
        name: "DashBoard",
        path: "/",
        component: DashBoard,
        meta: {
          title: "Dashboard",
          datatype: DataManager.data.ChargeStation,
          require_login: true,
          for_user: DataManager.UserTypes.All,
          group: "Dashboard",
          icon: "mdi-view-dashboard-variant-outline",
          group_icon: "mdi-view-dashboard-variant-outline",
          description: "Обобщена информация",
        },
      },
      {
        name: "CurrentState",
        path: "/CurrentState",
        component: CurrentState,
        meta: {
          title: "Зарядни станции",
          datatype: DataManager.data.ChargeStation,
          require_login: true,
          for_user: DataManager.UserTypes.All,
          group: "Зарядни станции",
          icon: "mdi-ev-station",
          group_icon: "mdi-ev-station",
          description: "Информация за зарядните станции",
        },
      },
      {
        name: "Transactions",
        path: "/Transactions",
        component: DataGrid,
        meta: {
          datatype: DataManager.data.Transactions,
          for_user: DataManager.UserTypes.All,
          require_login: true,
          title: "Заряди",
          group: "Заряди",
          icon: "mdi-format-list-numbered",
          group_icon: "mdi-format-list-numbered",
          description: "Справка заряди",
        },
      },
      {
        name: "Map",
        path: "/Map",
        component: ChargeStationMap,
        meta: {
          datatype: DataManager.data.ChargeStation,
          require_login: true,
          for_user: DataManager.UserTypes.SuperUser,
          title: "Карта",
          group: "Карта",
          icon: "mdi-map-marker-radius-outline",
          group_icon: "mdi-map-marker-radius-outline",
          description: "Карта на мрежата",
        },
      },
      {
        name: "Control",
        path: "/Control",
        component: ChargingStationControl,
        meta: {
          title: "Управление",
          datatype: DataManager.data.ChargeStation,
          for_user: DataManager.UserTypes.OnwerWithPermissions + DataManager.UserTypes.SuperUser,
          require_login: true,
          group: "Управление",
          icon: "mdi-remote",
          group_icon: "mdi-remote",
          description: "Управление на зарядните станции",
        },
      },
      // {
      //   name: "ForInvoice",
      //   path: "/ForInvoice",
      //   component: DataGrid,
      //   meta: {
      //     datatype: DataManager.data.ForInvoicing,
      //     for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.SuperUser,
      //     require_login: true,
      //     title: "За фактуриране",
      //     group: "За фактуриране",
      //     icon: "mdi-book-check-outline",
      //     group_icon: "mdi-book-check-outline",
      //     description: "Справка за фактуриране",
      //   },
      // },
      // {
      //   name: "Configuration",
      //   path: "/Configuration",
      //   component: ChargingStationConfiguration,
      //   meta: {
      //     title: "Конфигурация",
      //     datatype: DataManager.data.ChargeStation,
      //     for_user: DataManager.UserTypes.SuperUser, // + DataManager.UserTypes.Owner,
      //     require_login: true,
      //     group: "Конфигурация",
      //     icon: "mdi-cog-transfer-outline",
      //     group_icon: "mdi-cog-transfer-outline",
      //     description: "Конфигурация на зарядните станции",
      //   },
      // },
      {
        name: "DailyAmountByChargepoint",
        path: "/DailyAmountByChargepoint",
        component: DataGrid,
        meta: {
          datatype: DataManager.data.DailySalesByChargePoint,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.OnwerWithPermissions + DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Оборот станции по дни",
          group: "Справки",
          icon: "mdi-calendar-text-outline",
          group_icon: "mdi-view-grid-outline",
          description: "Оборот на станции по дни",
        },
      },
      {
        name: "DailyAmount",
        path: "/DailyAmount",
        component: DataGrid,
        meta: {
          datatype: DataManager.data.DailySales,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.OnwerWithPermissions+ DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Общ оборот по дни",
          group: "Справки",
          icon: "mdi-format-list-text",
          group_icon: "mdi-view-grid-outline",
          description: "Общ оборот за всички станции по дни",
        },
      },
      {
        name: "MonthlyAmount",
        path: "/MonthlyAmount",
        component: DataGrid,
        meta: {
          datatype: DataManager.data.MonthlySales,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.OnwerWithPermissions+ DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Общ оборот по месеци",
          group: "Справки",
          icon: "mdi-calendar-month-outline",
          group_icon: "mdi-view-grid-outline",
          description: "Обобщен оборот за всички станции по месеци",
        },
      },
      {
        name: "ChartDaily",
        path: "/ChartDaily",
        component: DataChart,
        meta: {
          datatype: DataManager.data.ChartDaily,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.OnwerWithPermissions + DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Оборот по дни",
          group: "Справки",
          icon: "mdi-chart-multiple",
          group_icon: "mdi-view-grid-outline",
          description: "Оборот от заряди по дни",
        },
      },
      {
        name: "ChartByStations",
        path: "/ChartByStations",
        component: DataChart,
        meta: {
          datatype: DataManager.data.ChartByStations,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.OnwerWithPermissions + DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Оборот по станции",
          group: "Справки",
          icon: "mdi-chart-bar",
          group_icon: "mdi-view-grid-outline",
          description: "Оборот по станции за период",
        },
      },
      // {
      //   name: "ChartByHours",
      //   path: "/ChartByHours",
      //   component: DataChart,
      //   meta: {
      //     datatype: DataManager.data.ChartByHours,
      //     for_user: DataManager.UserTypes.SuperUser,
      //     require_login: true,
      //     title: "Заряди по часове",
      //     group: "Справки",
      //     icon: "mdi-chart-timeline-variant-shimmer",
      //     group_icon: "mdi-view-grid-outline",
      //     description: "Брой заряди на автомобили по часове",
      //   },
      // },
      {
        name: "Clients",
        path: "/Clients",
        component: ClientsView,
        meta: {
          datatype: DataManager.data.EVUsers,
          for_user: DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Списък клиенти",
          group: "Клиенти",
          icon: "mdi-account-details-outline",
          group_icon: "mdi-account-group-outline",
          description: "Списък клиенти",
        },
      },
      // {
      //   name: "Invoices",
      //   path: "/Invoices",
      //   component: ToDo,
      //   meta: {
      //     datatype: null,
      //     for_user: DataManager.UserTypes.SuperUser,
      //     require_login: true,
      //     title: "Фактури",
      //     group: "Клиенти",
      //     icon: "mdi-receipt",
      //     group_icon: "mdi-account-group-outline",
      //     description: "Фактури",
      //   },
      // },
      {
        name: "Vehicles",
        path: "/Vehicles",
        component: DataGrid,
        meta: {
          datatype: DataManager.data.Cars,
          for_user: DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "Автомобили",
          group: "Клиенти",
          icon: "mdi-car-electric",
          group_icon: "mdi-account-group-outline",
          description: "Списък с автомобилите на клиентите",
        },
      },
      {
        name: "RFID",
        path: "/RFID",
        component: DataGrid,
        // props: { datatypeprop: DataManager.data.ChartByHours },
        meta: {
          datatype: DataManager.data.Cards,
          for_user: DataManager.UserTypes.SuperUser,
          require_login: true,
          title: "RFID карти",
          group: "Клиенти",
          icon: "mdi-card-text-outline",
          group_icon: "mdi-account-group-outline",
          description: "Списък RFID карти",
        },
      },

      {
        title: "Настройки",
        name: "settings",
        path: "/Settings",
        component: UserSettings,
        meta: {
          require_login: true,
          title: "Настройки",
          group: "Настройки",
          icon: "mdi-message-cog-outline",
          group_icon: "mdi-account-cog-outline",
          datatype: null, //DataManager.data.User,
          for_user: DataManager.UserTypes.All,
          description: "Конфигуриране интерфейса на приложението",
        },
      },

      // {
      //   path: "/about",
      //   name: "about",
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
      // },
    ],
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "NotFound",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.onError((error) => {
  console.log(error);
});

router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.internal && (Object.keys(to.query).length != 1 || to.query["internal"] != "true")) {
    next("/login");
    return;
  }
  from.matched.forEach((r) => {
    nextTick().then(() => {
      try {
        if (r.instances && r.instances.default && r.instances.default.setFocus) {
          r.instances.default.setFocus(false);
        }
      } catch {
        /**ignore */
      }
    });
    //next();
  });

  var found = false;
  to.matched.forEach((r) => {
    if (r.path == "/MainContent") {
      return;
    }
    if (r.path == "/login" && !!DataManager.user) {
      //tODO?
      //console.log("ALERT");
      alert(
        "Данните в приложението се опресняват автоматично и няма нужда да излизате и влизате отново.\nАко желаете да излезете от приложението, моля използвайте бутона Изход."
      );
      found = true;
      next(false);
    } else if (r.meta && r.meta.require_login && r.path != "/login" && r.path != "/landing" && !DataManager.user) {
      DataManager.__reload();
      found = true;
      next("/login");
    } else if (r.meta && r.meta.datatype) {
      if (!DataManager.userHasAccess(r.meta.for_user)) {
        found = true;
        next(false);
        return;
      }
      // bus.$emit(bus.EVENT_AddTab_In_MainContent, r.name);
      r.meta.datatype.isLoading = true;
      g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: 'Обработка на "' + r.meta.title + '"' }).then(() => {
        nextTick(() => {
          setTimeout(() => {
            DataManager.loadData(r.meta.datatype, (err) => {
              g_Dialog.close(false, true).then(() => {
                try {
                  if (r.instances && r.instances.default && r.instances.default.setMeta) {
                    r.instances.default.setMeta(r.meta, err);
                  }
                } catch {
                  /** ignored */
                }
                found = true;
                // next();
              });
            });
          }, 111);
        });
      });
    }
    return;
  });
  if (!found) {
    next();
  }
});

router.afterEach((to) => {
  to.matched.forEach((r) => {
    nextTick().then(() => {
      if (r.instances && r.instances.default && r.instances.default.setFocus) {
        r.instances.default.setFocus(true);
      }
    });
  });
});

// router.loadRouteData = function (r, force_choice) {
//   // if (r.meta.datatype.require_choice && (force_choice || !r.meta.datatype.datesFromTo || DataManager.data[r.meta.datatype.dataid].length == 0)) {
//   if (r.meta.datatype.require_choice && (force_choice || !r.meta.datatype.datesFromTo)) {
//     g_Dialog.show(g_Dialog.dialog_types.date_picker, r.meta.datatype.datesFromTo ?? null, null, (dates) => {
//       if (dates != null) {
//         r.meta.datatype.isLoading = true;
//         if (!r.meta.datatype.datesFromTo || r.meta.datatype.datesFromTo[0].getTime() != dates[0].getTime() || r.meta.datatype.datesFromTo[1].getTime() != dates[1].getTime()) {
//           g_Dialog
//             .show(g_Dialog.dialog_types.loader, null, {
//               message: "Зареждане на " + r.meta.title + (dates ? " за период " + dates[0].toTremolFpStringShort() + " - " + dates[1].toTremolFpStringShort() : "") + ", моля изчакайте",
//             })
//             .then(() => {
//               DataManager.loadData(
//                 r.meta.datatype,
//                 (err) => {
//                   g_Dialog.close().then(() => {
//                     if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
//                       r.instances.default.setMeta(r.meta, err);
//                     }
//                   });
//                 }
//                 // true,
//                 // dates[0],
//                 // dates[1],
//                 // DataManager.data[DataManager.DataType.devices.id].slice()
//               );
//             });
//         } else {
//           if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
//             r.instances.default.setMeta(r.meta);
//           }
//         }
//         r.meta.datatype.datesFromTo = dates;
//         // if (!r.meta.datatype.datesFromTo) {
//         //   Object.defineProperty(r.meta.datatype, "datesFromTo", {
//         //     configurable: true,
//         //     enumerable: true,
//         //   });
//         // }
//         // if (!r.meta.datatype.datesFromTo) {
//         //   r.meta.datatype.datesFromTo = [null, null]
//         // }
//         // r.meta.datatype.datesFromTo[0] = dates[0];
//         // r.meta.datatype.datesFromTo[1] = dates[1];
//       } else {
//         // g_Dialog.close().then(() => {
//         if (r.instances && r.instances.default && r.instances.default.setMeta) {
//           r.instances.default.setMeta(r.meta);
//         }
//         // });
//       }
//     });
//   } else {
//     r.meta.datatype.isLoading = true;
//     g_Dialog
//       .show(g_Dialog.dialog_types.loader, null, {
//         message: "Зареждане на " + r.meta.title + ", моля изчакайте",
//       })
//       .then(() => {
//         DataManager.loadData(
//           r.meta.datatype,
//           (err) => {
//             g_Dialog.close().then(() => {
//               nextTick().then(() => {
//                 if (r.instances && r.instances.default && r.instances.default.setMeta) {
//                   r.instances.default.setMeta(r.meta, err);
//                 }
//               });
//             });
//           }
//           // r.meta.force_load == true,
//           // r.meta.datatype.datesFromTo ? r.meta.datatype.datesFromTo[0] : undefined,
//           // r.meta.datatype.datesFromTo ? r.meta.datatype.datesFromTo[1] : undefined
//         );
//       });
//   }
//};

export default router;
